
import './App.css';
import Dictionary from "./Dictionary"; 

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header"> DICTIONARY</header>
        <main>
          <Dictionary defaultKeyword="sunshine" />
        </main>
        <footer className="App-footer">
          {" "}
          <a
            href="https://github.com/rcgatt/dictionary-project-react"
            target="_blank"
            rel="noreferrer"
          >
            Open-sourced project coded by C. Gatete
          </a>
        </footer>
      </div>
    </div>
  );
}


